import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { UseQueryResult, QueryFunctionContext } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { homePageQueryKeys } from "../services/queries/queryKeyFactory";
import type { ListsDto } from "../types/dto";

const useListsQuery = (): UseQueryResult<ListsDto> => {
    //TODO should refetchOnMount only when lists changed? what other conditions?
    return useQuery({
        queryKey: homePageQueryKeys.lists(),
        retry: false,
        throwOnError: true,
        queryFn({ signal }: QueryFunctionContext): Promise<ListsDto> {
            return salesApiService.home.fetchLists({
                cancellation: signal,
            });
        },
    });
};

export default useListsQuery;
